/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { UserSettings, UserSettingsResource, UserSettingsService } from '@alfa-client/user-settings-shared';
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-user-settings-email-benachrichtigung-container',
  templateUrl: './user-settings-email-benachrichtigung-container.component.html',
  standalone: false,
})
export class UserSettingsEmailBenachrichtigungContainerComponent implements OnInit {
  private readonly userSettingsService = inject(UserSettingsService);

  userSettings$: Observable<StateResource<UserSettingsResource>>;

  ngOnInit(): void {
    this.userSettings$ = this.userSettingsService.getUserSettings();
  }

  changeUserSettings(userSettings: UserSettings): void {
    this.userSettingsService.setUserSettings(userSettings);
  }
}
